<template>
  <section class="payout-details">
    <div class="back">
      <div @click="handleRedirect">
        <svg
          width="19"
          height="16"
          viewBox="0 0 19 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M19 7L4.92969 7L9.5 2.42969L8 0.929687L0.929687 8L8 15.0703L9.5 13.5703L4.92969 9L19 9L19 7Z"
            fill="#655D79"
          />
        </svg>
      </div>
      <p>PAYOUTS</p>
    </div>
    <Table
      :contents="contents.contents"
      :pageInfo="contents.pageInfo"
      :onPageChange="() => {}"
      :loading="contents.loading"
      :noClickEvent="isFundingHistory() ? true : false"
      :lightAmountColor="true"
      :showFliter="state.showFliter"
      :showExport="state.showExport"
      :hidePrimaryButton="true"
      :handleExportDownload="handleExportDownload"
      :clearFilter="clearFilter"
      singleDetailRouteName="view-payout-single-details"
      additionalRouteKey="payout_reference"
      additionalRouteName="reference"
      showTab
    >
      <template v-slot:tab>
        <Tab :tabs="state.tabs" />
      </template>
      <template v-slot:default="slotProps">
        <div class="filter" v-if="slotProps.openFilters && !isFundingHistory()">
          <Input
            label="Merchant"
            :value="state.filter.merchant_name"
            :onChange="(value) => (state.filter.merchant_name = value)"
          />
          <Input
            label="Recipient"
            :value="state.filter.beneficiary_account_name"
            :onChange="
              (value) => (state.filter.beneficiary_account_name = value)
            "
          />
          <Input
            label="Status"
            :value="state.filter.status"
            :onChange="(value) => (state.filter.status = value)"
          />
          <Input
            label="Amount"
            :value="state.filter.amount"
            inputType="number"
            :onChange="(value) => (state.filter.amount = value)"
          />
          <Datepicker
            label="Transaction Date"
            :value="state.filter.createdAt"
            :onDateSelected="
              (value) =>
                (state.filter.createdAt = `${moment(value).format(
                  'YYYY-MM-DD'
                )}`)
            "
          />
          <div class="form__item">
            <div class="form__label">Bank</div>
            <div class="select">
              <select
                class="select__input select__input--sm"
                v-model="state.filter.bank_code"
              >
                <option
                  v-for="bank in bankList"
                  :value="bank.code"
                  :key="bank.code"
                >
                  {{ bank.bank }}
                </option>
              </select>
              <div class="select__icon">
                <svg
                  height="10"
                  viewBox="0 0 6 10"
                  width="6"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M6.03 3.03L3.025.025.02 3.03h6.01zM5.88 7.071L2.975 9.975.07 7.07H5.88z"
                    fill="#637381"
                    fill-rule="evenodd"
                  />
                </svg>
              </div>
            </div>
          </div>
          <Input
            label="Transaction Reference"
            :value="state.filter.payout_reference"
            :onChange="(value) => (state.filter.payout_reference = value)"
          />
          <Button
            buttonName="Apply Fliter"
            :onClick="handleApplyFliter"
            classes="primary"
          />
        </div>
        <div class="filter" v-if="slotProps.openFilters && isFundingHistory()"  >
          <Input label="Status" :value="state.filter.status"  :onChange="value => state.filter.status = value" />
          <Input label="Transaction Reference"  :value="state.filter.transaction_reference"   :onChange="value => state.filter.transaction_reference = value" />
<!--          <Datepicker label="Transaction Date" :value="state.filter.payout_date"  :onDateSelected="value => state.filter.payout_date = `${moment(value).format('YYYY-MM-DD')}`"  />-->

            <date-range-picker
                    control-container-class="."
                    ref="picker"
                    :locale-data="{ firstDay: 1, format: 'DD-MM-YYYY HH:mm:ss' }"
                    :singleDatePicker="true"
                    :autoApply="true"
                    v-model="state.dateRange"
                    @update="updateDate"
            >
                <template v-slot:input style="min-width: 350px;">
                    <div class="form__item custom-input" style="margin-top:-34px !important">
                        <div class="label-icon">
                            <div class="form__label">Transaction Date</div>
                        </div>
                        <div class="form__input">{{state.filter.payout_date || '&nbsp;'}}</div>
                    </div>
                </template>
            </date-range-picker>
          <Button buttonName="Apply Fliter" :onClick="handleApplyFliter" classes="primary" />
        </div>
      </template>
    </Table>
  </section>
</template>
<script>
import Table from "@/components/table.vue"
import Tab from "@/components/tab.vue"
import DateRangePickers from "@/components/daterange.vue"
import { reactive, onBeforeMount, computed, watch } from '@vue/composition-api'
import Datepicker from "@/components/datepicker.vue"
import Input from "@/components/input.vue"
import Button from "@/components/button.vue"
import DateRangePicker from 'vue2-daterange-picker'

import moment from 'moment';
export default {
  components: {
    Table,
    Input,
    Button,
    Datepicker,
    DateRangePickers,
    Tab, DateRangePicker
  },
  setup(props, { root }) {
    const store = root.$store;
    const { params, path } = root.$route;
    const isFundingHistory = () =>
      root.$route.path.startsWith("/dashboard/payouts/fundinghistory/");

    const state = reactive({
      showExport: true,
      showFliter: true,
      filter: {
        from: moment().subtract(12, "months"),
        to: moment(),
      },
      tabs: [
        {
          url: `/dashboard/payouts/${params.id}`,
          name: "Recent Payouts",
        },
        {
          url: `/dashboard/payouts/fundinghistory/${params.id}`,
          name: "Funding History",
        },
      ],
        dateRange: { endDate: moment(), startDate: moment()}
    })

    const dispatch = () => {
      if (isFundingHistory()) {
        store.dispatch("getPayoutDetails", {
          ...root.$route.query,
          ...root.$route.params,
          ...state.filter,
          type: "fundinghistory",
        });
      } else {
        store.dispatch("getPayoutDetails", {
          ...root.$route.query,
          ...root.$route.params,
          ...state.filter,
          type: "payouts",
        });
      }
    };

    onBeforeMount(() => {
      dispatch();
    });
    // watch query changes
    watch(
      () => root.$route.query,
      () => {
        dispatch();
      }
    );

    watch(
      () => root.$route.path,
      () => {
        dispatch();
      }
    );

    const contents = computed(() => store.getters.getPayoutDetails);
    const bankList = computed(() => store.getters.getBankList);

    const handleRedirect = () =>
      root.$router.push({ name: "view-payout-dashboard" });
    const handleApplyFliter = () => {
      dispatch();
    };
    const onDateSelected = ({ startDate, endDate }) => {
      state.filter.from = startDate;
      state.filter.to = endDate;
    };
    const handleExportDownload = (type) =>
      store.dispatch("download", {
        downloadType: type,
        url: isFundingHistory()
          ? `dashboard/admin/${root.$route.params.id}/account/history?download=true`
          : `dashboard/admin/${root.$route.params.id}/payouts/history?download=true`,
        key: isFundingHistory() ? "funding_history" : "transaction_history",
        filter: state.filter,
        fileName: "payouts",
      });

    const clearFilter = () => {
      state.filter = {}
      dispatch()
    }

        const updateDate = (date) => {
            state.filter.createdAt = `${moment(date.endDate).format('YYYY-MM-DD')}`
        }
    return {
      contents,
      state,
      handleRedirect,
      handleApplyFliter,
      onDateSelected,
      handleExportDownload,
      moment,
      clearFilter,
      isFundingHistory,
      bankList, updateDate
    }
  }
}
</script>
<style lang="scss">
.payout-details {
  margin: 30px 25px;

  .table-component {
    margin: 0;
    width: 100%;
  }

  .label-icon {
    margin-bottom: 0 !important;
  }

  .select__input--sm {
    padding: 9px 30px;
  }

  .back {
    display: flex;
    padding-bottom: 30px;
    > div {
      cursor: pointer;
      padding-right: 19px;
    }
  }
  .filter {
    display: flex;
    justify-content: flex-end;
    align-items: flex-end;
    padding: 0 24px;
    .button-comp {
      margin-left: 20px;
      margin-bottom: 30px;
    }
    .vue-daterange-picker {
      height: 67px;
      margin-left: 25px;
    }
  }

.overview {
    display: flex;
    margin-bottom: 32px;
    &__item {
        background: #ffffff;
        border: 1px solid rgba(97, 110, 124, 0.2);
        box-sizing: border-box;
        box-shadow: 0px 8px 14px rgba(0, 0, 0, 0.05);
        border-radius: 6px;
        flex-basis: 50%;
        &:last-child {
            margin-left: 32px;
        }

        &__top {
            padding: 24px;
            display: flex;
            justify-content: space-between;
        }

        &__bottom {
            padding: 27px 24px 24px;
            display: flex;
            justify-content: space-between;
            border-top: 1px solid #ebf0f4;
        }

        &__value {
            font-size: 36px;
            line-height: 43px;
            margin-bottom: 13px;
        }

        &__caption {
            color: rgba(38, 25, 64, 0.7);
            font-size: 14px;
            margin-bottom: 27px;
        }

        &__action {
            a {
                color: #e00b5b;
                text-decoration: none;
                text-transform: uppercase;
            }
        }

        &__number {
            color: rgba(38, 25, 64, 0.7);
        }
    }
}

.orange {
    color: #f8a061;
}

.name {
    color: #261940;
    display: block;
    margin-bottom: 4px;
}

.email {
    color: rgba(38, 25, 64, 0.6);
    font-size: 12px;
}

.header {

position: absolute;
width: 1071px;
height: 505px;
left: 313px;
top: 370px;

background: #FFFFFF;
border-radius: 6px;
}
.title {
    position: absolute;
width: 87px;
height: 20px;
left: 477.85px;
top: 402px;

font-family: Calibre;
font-style: normal;
font-weight: normal;
font-size: 14px;
line-height: 20px;

color: rgba(50, 63, 75, 0.5);
}

.info {

position: absolute;
width: 1071px;
height: 505px;
left: 313px;
top: 370px;

background: #FFFFFF;
border-radius: 6px;
}
.pagination {

font-family: Calibre;
font-style: normal;
font-weight: normal;
font-size: 16px;
line-height: 14px;
/* identical to box height, or 87% */


color: #000000;

.active {

font-size: 16px;
line-height: 14px;
/* identical to box height, or 87% */


color: #FFFFFF;

position: absolute;
width: 29.97px;
height: 30px;
left: 783.56px;
top: 805px;

background: #e00b5b;
border-radius: 4px;
}
}
.filter {

position: absolute;
width: 54px;
height: 16px;
left: 1143px;
top: 176px;

font-family: Calibre;
font-style: normal;
font-weight: normal;
font-size: 14px;
line-height: 16px;
/* identical to box height */


color: #e00b5b;
}
}
</style>